import type { IconProps } from './types';

export const GlobeIcon: React.FC<IconProps> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <rect width="24" height="24" fill="none" />
            <g id="_9027324_language_icon" transform="translate(1.049 1.497)">
                <circle
                    cx="9"
                    cy="9"
                    r="9"
                    transform="translate(1.951 1.503)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.5"
                />
                <path
                    d="M11.519,18.9a10.631,10.631,0,0,0,3.519-8.449A10.631,10.631,0,0,0,11.519,2,10.631,10.631,0,0,0,8,10.449,10.631,10.631,0,0,0,11.519,18.9Z"
                    transform="translate(-0.724 0.282)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                />
                <path
                    d="M2.5,9H19.216M2.5,14.279H19.216"
                    transform="translate(-0.063 -0.908)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                />
            </g>
        </svg>
    );
};
